"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="px-4 lg:px-6 mx-auto xl:container full text-center pt-20">
      <h2>Desverre gikk noe galt!</h2>
      <button
        className="button"
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Prøv igjen
      </button>

      <div className="py-20">Kontakt oss hvis problemet vedvarer.</div>
    </div>
  );
}
